import { driver } from '@/data'
import { CellsResponseData, GetCellValuesParams } from '@/data/interface'
import { useCallback } from 'react'

export interface GetSheetValuesParams {
  pageSize?: number
  pageNumber?: number
  fieldKey?: string
  searchField?: string
  searchValue?: string
}

export function useSheetValues(sheetId: string) {
  /**
   * Fetches cell values with pagination, filtering, and sorting support
   */
  const getCellValues = useCallback(
    async (params: GetSheetValuesParams): Promise<CellsResponseData> => {
      // Convert our params to the data layer's GetCellValuesParams
      const dataParams: GetCellValuesParams = {
        sheetId,
        pageSize: params.pageSize,
        pageNumber: params.pageNumber,
        fieldKey: params.fieldKey,
        searchField: params.searchField,
        searchValue: params.searchValue,
      }

      try {
        return await driver.getCellValues(dataParams)
      } catch (error) {
        console.error('Error fetching cell values:', error)
        return {
          data: {
            values: [],
            total: 0,
            pageSize: params.pageSize || 100,
            pageNumber: params.pageNumber || 0,
          },
          success: false,
        }
      }
    },
    [sheetId]
  )

  return {
    getCellValues,
  }
}
